import "react-datepicker/dist/react-datepicker.css"
import "./style.css"

import PropTypes from "prop-types"
import React, { forwardRef, useState } from "react"
import ReactDatePicker from "react-datepicker"
import { useTranslation } from "react-i18next"

import { getDateFormat } from "../../../../utils/utils"

const CustomDatePicker = ({
    errorData,
    className,
    placeHolder,
    selected,
    value,
    name,
    onChangehandler,
    isFutureDateDisabled,
    isPastDateDisabled = false,
    isClearable = false,
    disabled,
    minimumDate,
    endDate,
    isselectsEnd,
    maximumDate,
    popupPlacement,
    isRequired = true, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    isComponentLabelValidation = true, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    onlyYearCalendar = false, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    labelIsRequired = true, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    onlyMonthYearCalendar = false
}) => {
    const isValid = errorData[name] ? false : true
    const CLASS_NAME =
        "custom__datepicker block disabled:bg-lighestgray w-full"+
        " p-3 text-sm text-gray-900 bg-transparent rounded-lg border"+ 
        " border-lightGray appearance-none focus:outline-none focus:ring-0"+
        " focus:border-primary-100 focus:bg-lightSkyblue hover:border-primary-100"+
        " text-gray-900 focus:outline-none focus:ring-0 focus:border-primary-100 peer transition duration-300"
    const { t } = useTranslation()
    const [placeholderLabel, setPlaceholderLabel] = useState(false)
    const [showLabel, setShowLabel] = useState(true)
    const date_format = sessionStorage.getItem("dateFormatBasedOnCountry")
    const ExampleCustomInput = forwardRef(
        (
            { value, onClick, onChange, placeHolder, id },
            ref
        ) => (
            <>
                <input
                    value={ value }
                    className={
                        isValid
                            ? `${className + CLASS_NAME}`
                            : "border-red " + className + CLASS_NAME
                    }
                    onClick={ onClick }
                    onChange={ onChange }
                    placeholder={ placeHolder }
                    ref={ ref }
                    id={ id }
                    disabled={ disabled }
                    autoComplete="off"
                   
                ></input>

                { labelIsRequired && <label
                    htmlFor={ id }
                    className="absolute flex text-sm text-placeHolderColor duration-300 
                    transform -translate-y-[28px] scale-75 top-16 origin-[0] 
                    bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 
                    peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                    peer-placeholder-shown:top-1/2 peer-focus:top-16 peer-focus:scale-75 
                    peer-focus:-translate-y-[28px] rtl:peer-focus:translate-x-1/2 
                    rtl:peer-focus:left-auto start-17 cursor-text font-['Avenir'] font-normal"
                >
                    { isRequired && <span className="text-red text-sm mr-1 flex">*</span> }
                    { placeHolder }
                </label> }
            </>
        )
    )

    ExampleCustomInput.propTypes = {
        id: PropTypes.string,
        isValid: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        placeHolder: PropTypes.string,
        value: PropTypes.string
    }

    ExampleCustomInput.displayName = "ExampleCustomInput"

    const YearLimit = new Date()
    YearLimit.setFullYear(2099, 11, 31)
    return (
        <>
            {
                onlyYearCalendar ?
                    <ReactDatePicker
                        selected={ selected }
                        popperPlacement={ popupPlacement }
                        onChange={ (data) => onChangehandler(data, name) }
                        value={ value ? value : "" }
                        showYearPicker                       
                        dateFormat="yyyy"
                        wrapperClassName="w-full"
                        customInput={ <ExampleCustomInput placeHolder={ placeHolder } /> }
                        id={ name }
                        maxDate={
                            isFutureDateDisabled ? maximumDate ? new Date(maximumDate) : new Date(): YearLimit
                        }
                    /> :
                    onlyMonthYearCalendar ?
                        <ReactDatePicker
                            selected={ selected }
                            popperPlacement={ popupPlacement }
                            onChange={ (data) => onChangehandler(data, name) }
                            value={ value ? value : "" }
                            showYearDropdown
                            showMonthYearPicker                             
                            dropdownMode="select"                    
                            dateFormat={ "MM/yyyy" }
                            wrapperClassName="w-full"
                            customInput={ <ExampleCustomInput placeHolder={ placeHolder } /> }
                            id={ name }
                            isClearable={ isClearable }
                            minDate={
                                isPastDateDisabled
                                    ? endDate
                                        ? new Date(endDate)
                                        : new Date("1900-01-01")
                                    : minimumDate
                                        ? new Date(minimumDate)
                                        : {}
                            }
                            maxDate={
                                isFutureDateDisabled ? maximumDate ? new Date(maximumDate) : new Date(): YearLimit
                            }                
                        /> :
                        <div className="relative">
                            <ReactDatePicker
                                className={
                                    isValid
                                        ? `${className + CLASS_NAME}`
                                        : "border-red " + className + CLASS_NAME
                                }
                                toggleCalendarOnIconClick
                                popperPlacement={ popupPlacement }
                                selected={ selected }
                                dateFormat={ date_format ? date_format : getDateFormat() }
                                disabled = { disabled }
                                onChange={ (data) => {
                                    onChangehandler(data, name)
                                    setPlaceholderLabel(true)
                                    setShowLabel(false)
                                    
                                } }
                                onBlur={ ()=>{
                                    if(!selected) {
                                        setPlaceholderLabel(false)
                                        setShowLabel(true)
                                    }
                                    
                                } }
                                onFocus={ ()=>{ 
                                    if(!selected) {
                                        setPlaceholderLabel(true)
                                        setShowLabel(false)} 
                                }
                                }
                                id={ name }
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"                            
                                autoComplete="off"
                                minDate={
                                    isPastDateDisabled
                                        ? endDate
                                            ? new Date(endDate)
                                            : new Date("1900-01-01")
                                        : minimumDate
                                            ? new Date(minimumDate)
                                            : {}
                                }
                                wrapperClassName="w-full"
                                selectsEnd={ isselectsEnd }
                                maxDate={
                                    isFutureDateDisabled ? maximumDate ? new Date(maximumDate) : new Date(): YearLimit
                                }
                           
                            />
                            { (placeholderLabel || value) && <label
                                htmlFor={ name }
                                className="absolute flex text-sm font-normal 
                                text-placeHolderColor duration-300 
                                transform -translate-y-[0px] scale-75 
                                h-[4px] left-[16px] peer-focus:h-[1px] 
                                items-center peer-focus:items-center 
                                gap-[0px] peer-focus:gap-[0px] 
                                peer-focus:top-[0px] top-[-1px] 
                                peer-placeholder-shown:top-[23px] 
                                peer-placeholder-shown:-translate-y-1/2 
                                peer-placeholder-shown:scale-100 peer-placeholder-shown:left-[12px]
                                 peer-focus:text-blue-600 bg-white peer-focus:scale-75 
                                 peer-focus:left-[16px] bg-white peer-focus:-translate-y-[0px]
                                  origin-[0]"
                            >
                                { isRequired && <span className="text-red text-sm mr-1 flex">*</span> }
                                { placeHolder }
                            </label> }
                            { showLabel && !value && <label
                                htmlFor={ name }
                                className="absolute flex text-sm duration-300 
 transform top-16 origin-[0] bg-white 
 dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 
 peer-placeholder-shown:scale-100 -translate-y-1/2 
 peer-placeholder-shown:top-1/2 peer-focus:top-16
 rtl:peer-focus:translate-x-1/2 
 rtl:peer-focus:left-auto start-17 cursor-text font-['Avenir'] font-normal text-placeHolderColor"
                            >
                                { isRequired && <span className="text-red text-sm mr-1 flex">*</span> }
                                { placeHolder }
                            </label> }
                        </div>
            }
            { isComponentLabelValidation && errorData[name] && (
                <span className="text-red text-xs font-normal font-['Avenir'] leading-[14px]">
                    { t(`errorMessage.${name}`) }
                </span>
            ) }
        </>
    )
}

CustomDatePicker.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    endDate: PropTypes.instanceOf(Date),
    errorData: PropTypes.object.isRequired,
    isFutureDateDisabled: PropTypes.bool,
    isPastDateDisabled: PropTypes.bool,
    isselectsEnd: PropTypes.bool,
    minimumDate: PropTypes.instanceOf(Date),
    name: PropTypes.string,
    onChangehandler: PropTypes.func,
    placeHolder: PropTypes.string,
    //selected: PropTypes.instanceOf(Date),
    startDate: PropTypes.instanceOf(Date),
    value: PropTypes.string,
    maximumDate: PropTypes.instanceOf(Date)
}

export default CustomDatePicker
